import {Locales} from '@netx/core-next/locales/utils/Locales';

export const RenameFormDialogTitle = Locales((i18n) => ({
	RENAME: i18n('i18n.rename'),
}));

export const RenameFormDialogLabel = Locales((i18n) => ({
	NAME: i18n('i18n.name'),
	SAVE: i18n('i18n.save'),
}));
